import React from 'react';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';
import DataRoomEmptyImage from 'assets/images/data-room-empty-image.webp';
import { useTranslation } from 'react-i18next';

import './ShareableLinkDocumentsListEmptyState.styles.scss';

type ShareableLinkDocumentsListEmptyStateProps = {
  className?: string;
};

const ShareableLinkDocumentsListEmptyState: React.FC<
  ShareableLinkDocumentsListEmptyStateProps
> = (props) => {
  const { className } = props;

  const classes = classNames(
    'shareable-link-documents-list-empty-state',
    className,
  );

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <ResolveImage
        src={DataRoomEmptyImage}
        asIllustration
        alt="There are no files yet."
      />
      <p>{t('noFilesAvailable')}</p>
    </div>
  );
};

export default ShareableLinkDocumentsListEmptyState;
